import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@tkww/the-bash-frontend';

export const ResultsCount = ({
  resultsCountFrom,
  resultsCountTo,
  resultsTotal,
  'data-testid': dataTestId,
}) => (
  <Typography
    variant="small"
    sx={{ display: 'block', marginBottom: 2, textAlign: 'center' }}
    data-testid={dataTestId}
  >
    Results {resultsCountFrom} - {resultsCountTo} of {resultsTotal}
  </Typography>
);

ResultsCount.propTypes = {
  resultsCountFrom: PropTypes.number,
  resultsCountTo: PropTypes.number.isRequired,
  resultsTotal: PropTypes.number.isRequired,
  'data-testid': PropTypes.string,
};

ResultsCount.defaultProps = {
  resultsCountFrom: 1,
  'data-testid': 'results-count',
};

export default ResultsCount;
